<template>
  <div class="drag-selector" v-show="show" ref="selector" :style="style"></div>
</template>

<script>
import $ from 'jquery';
import eventProxy from '@/scripts/tools/eventProxy';

export default {
  props: {
    layout: {
      type: String,
      default: 'grid',
    },
  },
  data() {
    return {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0,
      originY: 0, // 鼠标点击时y坐标原点
      style: {},
      pageX: 0,
      pageY: 0,
      pageW: 0,
      pageH: 0,
      show: false,
      selecting: false,
      move: false,
      beforeScroll: 0,
      currScroll: 0,
      offsetScroll: 0,
      // fileBody: null,
      scrollTimer: 0,
    };
  },
  computed: {
    fileBody() {
      return this.layout === 'grid'
        ? $('.grid-body')
        : $('.tc-15-table-fixed-body');
    },
  },
  mounted() {
    $(document)
      .on('mousedown ', this.mousedown)
      .on('mousemove', this.mousemove)
      .on('mouseup', this.mouseup)
      .on('dragstart', this.dragstart);
    eventProxy.on('command.stop-select', this.stopSelect);
    eventProxy.on('command.stop-select', this.stopSelect);
  },
  beforeDestroy() {
    $(document)
      .off('mousedown ', this.mousedown)
      .off('mousemove', this.mousemove)
      .off('mouseup', this.mouseup)
      .off('dragstart', this.dragstart);
    eventProxy.off('command.stop-select', this.stopSelect);
  },
  methods: {
    checkIfAllowSelector(e) {
      const $target = $(e.target);
      const $parents = $target.parents().add($target);
      if (
        (e.which === 1
          && e.target.tagName !== 'INPUT'
          && e.target.tagName !== 'BUTTON'
          && e.target.tagName !== 'TEXTAREA'
          && e.target.tagName !== 'A'
          && !$parents.filter('A').length
          && $parents.hasClass('page')
          && !$parents.hasClass('corner')
          && !$parents.hasClass('qc-bubble')
          && !$parents.hasClass('dialog-box')
          && !$parents.hasClass('dialog__mask')
          && !$parents.hasClass('disable-select'))
        // 若目标对象有类 allow-selection，则允许选区
        || $target.hasClass('allow-selection')
      ) {
        return true;
      }
      return false;
    },
    mousedown(e) {
      this.beforeScroll = this.fileBody && this.fileBody.scrollTop();
      this.currScroll = this.beforeScroll;
      this.move = false;
      $('.dialog__container').parent().addClass('dialog-box');
      if (this.checkIfAllowSelector(e)) {
        const $page = $('.page');
        const page = $page[0];
        const offset = $page.offset();
        this.pageX = offset.left;
        this.pageY = offset.top;
        this.pageW = page.offsetWidth;
        this.pageH = page.offsetHeight;

        const x = e.clientX;
        const y = e.clientY;
        [this.x1, this.x2] = [x, x];
        [this.y1, this.y2] = [y, y];
        this.originY = e.clientY;
        this.selecting = true;
        this.update('start');
      }
    },
    mousemove(e) {
      this.move = true;
      if (e.which !== 3 && this.selecting) {
        this.x2 = e.clientX;
        this.y2 = e.clientY;
        this.show = true;
        this.update('move');
      }
    },
    mouseup(e) {
      const $target = $(e.target);
      const $parents = $target.parents().add($target);
      $('.dialog__container').parent().addClass('dialog-box');
      if (e.which === 1 && this.selecting) {
        this.x2 = e.clientX;
        this.y2 = e.clientY;
        this.show = true;
        if (
          $parents.hasClass('page')
          && !$parents.hasClass('qc-bubble')
          && !$parents.hasClass('dialog-box')
          && !$parents.hasClass('dialog__mask')
        ) {
          this.update('end');
        }
      }
      if (this.checkIfAllowSelector(e) && !this.selecting) {
        this.update('end');
      }
      if (e.which === 1) {
        this.selecting = false;
        this.show = false;
      }
      this.move = false;
      [this.offsetScroll, this.currScroll] = [0, 0];
    },
    dragstart(e) {
      e.target.getAttribute('draggable');
      if (e.target.getAttribute('draggable') !== 'true') {
        e.preventDefault();
      }
    },
    stopSelect() {
      this.selecting = false;
      this.show = false;
    },
    update(type) {
      const { y1, y2 } = this;
      let [x1, x2] = [Math.min(this.x1, this.x2), Math.max(this.x1, this.x2)];
      let [reactY1, reactY2] = [y1, y2]; // 选区实际偏移
      let [viewY1, viewY2] = [y1, y2]; // 选区视觉偏移
      if (this.show) {
        const rectY1 = this.fileBody.offset().top;
        const rectY2 = rectY1 + this.fileBody.height();
        const currScroll = this.fileBody.scrollTop();
        const totalOffsetScroll = currScroll - this.beforeScroll;
        const offsetScroll = currScroll - this.currScroll;
        this.offsetScroll += offsetScroll;

        if (totalOffsetScroll > 0) {
          reactY2 += totalOffsetScroll;
          this.offsetScroll = Math.min(
            this.offsetScroll,
            this.originY - rectY1,
          );
          viewY1 -= this.offsetScroll;
          viewY1 = Math.max(viewY1, rectY1);
        } else if (totalOffsetScroll < 0) {
          reactY1 += totalOffsetScroll;
          this.offsetScroll = Math.max(
            this.offsetScroll,
            this.originY - rectY2,
          );
          viewY2 -= this.offsetScroll;
          viewY2 = Math.min(viewY2, rectY2);
        }
        this.currScroll = currScroll;
      }
      x1 = Math.max(this.pageX, x1);
      x2 = Math.min(this.pageX + this.pageW, x2);
      const _reactY1 = Math.min(reactY1, reactY2);
      const _reactY2 = Math.max(reactY1, reactY2);
      eventProxy.emit(`command.selector-${type}`, {
        x1,
        y1: _reactY1,
        x2,
        y2: _reactY2,
      });

      this.style = {
        left: `${x1 - this.pageX}px`,
        top: `${Math.min(viewY1, viewY2) - this.pageY}px`,
        width: `${x2 - x1}px`,
        height: `${Math.abs(viewY2 - viewY1)}px`,
        move: this.move,
      };
    },
  },
};
</script>
